/** Endpoint catalogues : alimente les dropdowns du formulaire DPE. */

import { apiFetch } from "@/api/client";

export type CatalogOption = {
  key: string;
  label?: string;
  description?: string;
  u0_w_per_m2_k?: number;
  uw_w_per_m2_k?: number;
  u_w_per_m2_k?: number;
  u_target?: number;
  efficiency?: number;
  cop?: number;
  heat_loss_multiplier?: number;
  energy?: string;
};

export type ImprovementOption = CatalogOption & {
  applicator?: string;
  cost_unit?: string;
  // V2 — Famille de travaux (segmentation : isolation, chauffage, enr…).
  family?: string;
};

export type BouquetOption = CatalogOption & {
  improvements?: string[];
};

export type TutorialGif = {
  path: string;
  caption?: string;
};

export type TutorialOption = {
  key: string;
  title: string;
  summary?: string;
  body_md?: string;
  gifs?: TutorialGif[];
  duration_min?: number;
};

export type RecommendedBouquet = {
  label: string;
  target_class: string;
  description: string;
  improvements: string[];
  notes?: string[];
};

export type UsageTip = {
  icon: string;
  title: string;
  description: string;
  saving_pct?: string;
};

export type MaintenanceTip = {
  icon: string;
  title: string;
  description: string;
  frequency: string;
  legal: boolean;
};

export type FieldJustification = {
  label: string;
  justifications: string[];
  fallback?: string;
};

export type Catalogs = {
  walls: CatalogOption[];
  wall_insulations: CatalogOption[];
  roofs: CatalogOption[];
  roof_insulations: CatalogOption[];
  low_floors: CatalogOption[];
  low_floor_insulations: CatalogOption[];
  windows: CatalogOption[];
  doors: CatalogOption[];
  heating_generators: CatalogOption[];
  ecs_generators: CatalogOption[];
  ventilation_types: CatalogOption[];
  adjacent_options: CatalogOption[];
  improvements: ImprovementOption[];
  bouquets: BouquetOption[];
  tutorials: TutorialOption[];
  // V4 — Bouquets structurés par classe DPE
  bouquets_by_class?: Record<string, Record<string, RecommendedBouquet>>;
  usage_tips?: UsageTip[];
  maintenance_tips?: MaintenanceTip[];
  field_justifications?: Record<string, FieldJustification>;
  // V5 — Applicateurs mutuellement exclusifs (déduplication set suggéré).
  exclusive_applicators?: string[];
};

export function getCatalogs() {
  return apiFetch<Catalogs>("/catalogs");
}
